<template>
  <v-snackbar :value="!!toastMessage" @input="closeToast" :timeout="-1" top right color="transparent" elevation="0" class="global-chat-toast">
    <template v-if="toastMessage">
      <v-card dark rounded="xl" class="pa-3 glass-card" @click="goToChat">
        <div class="d-flex">
          <v-avatar class="mr-3" color="grey darken-2">
            <v-img v-if="toastMessage.senderId.bild" :src="'/img/profilbilder/' + toastMessage.senderId.bild"></v-img>
            <span v-else>{{ getInitials(toastMessage.senderId) }}</span>
          </v-avatar>

          <div style="overflow: hidden">
            <div class="font-weight-bold">
              {{ groupName }}
            </div>
            <div class="caption text-truncate">
              <strong class="primary--text text--lighten-2"> {{ toastMessage.senderId.vorname }}: </strong>
              {{ toastMessage.textContent }}
            </div>
          </div>

          <v-btn icon small class="ml-2" @click.stop="closeToast">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card>
    </template>
  </v-snackbar>
</template>
<script>
// --- HIER DER FIX: 'mapMutations' importieren ---
import { mapState, mapGetters, mapActions, mapMutations } from "vuex"

export default {
  name: "GlobalChatToast",
  computed: {
    // (Dein 'computed'-Block ist 100% korrekt und bleibt gleich)
    ...mapState("chatStore", ["globalToastMessage", "chatGroups"]),
    toastMessage() {
      return this.globalToastMessage
    },
    groupName() {
      if (!this.toastMessage || !this.chatGroups || this.chatGroups.length === 0) {
        return "Neue Nachricht"
      }
      const group = this.chatGroups.find((g) => g._id === this.toastMessage.groupId)
      return group ? group.name : "Neue Nachricht"
    },
  },
  methods: {
    // --- HIER DER FIX ---
    ...mapActions("chatStore", {
      // 'closeToastAction: "SET_GLOBAL_TOAST"' WIRD HIER ENTFERNT
      selectChatGroup: "setActiveGroup",
    }),

    // --- UND HIER HINZUGEFÜGT ---
    ...mapMutations("chatStore", {
      // Wir mappen die MUTATION auf einen lokalen Methodennamen
      setToast: "SET_GLOBAL_TOAST",
    }),

    getInitials(user) {
      if (!user) return "?"
      const v = user.vorname || ""
      const n = user.nachname || ""
      return `${v.charAt(0).toUpperCase()}${n.charAt(0).toUpperCase()}`
    },

    /**
     * Schliesst den Toast
     */
    closeToast() {
      // --- HIER DER FIX ---
      // Wir rufen jetzt die Mutation auf, nicht die (nicht-existente) Action
      this.setToast(null)
    },

    /**
     * Springt zum Chat (die "Richtig Geil"-Funktion)
     */
    goToChat() {
      // (Dieser Teil war schon korrekt)
      this.selectChatGroup(this.toastMessage.groupId)
      if (this.$route.name !== "Chat") {
        this.$router.push("/chat")
      }
      this.closeToast() // Ruft die jetzt gefixte 'closeToast'-Methode auf
    },
  },
}
</script>
<style lang="scss" scoped>
/* WICHTIG: 'deep' ist nötig, damit wir das 'v-snackbar' Wrapper-Styling killen */
.global-chat-toast::v-deep .v-snack__wrapper {
  padding: 8px;
}

/* Der "Glassmorphism"-Effekt, den du wolltest */
.glass-card {
  background: rgba(40, 40, 40, 0.8) !important; /* Dunkles Glas */
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
  cursor: pointer;
  transition: all 0.2s ease-out;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4) !important;
  }
}
</style>
